export default __webpack_public_path__ + "static/media/bhim.ddcba890.webp";